// @flow
import tripPriceBuilder from './tripPrice'

// Types
import type { PriceUpdate } from '../../../models/price'
import type { OndeamndPriceUpdate } from '../../../api_types'

/**
 * Converts on-demand pricing API response to general pricing update object
 * @param  {Object} data
 * @return {PriceUpdate}
 */
function buildOndemandPriceUpdate(data: OndeamndPriceUpdate): PriceUpdate {
  const getPricePart = (
    name: 'price' | 'original_price' | 'coupon_discount'
  ) => ({
    price: !data.fixed
      ? undefined
      : {
          total_price: data.fixed[name],
        },
    estimates: !data.estimates
      ? undefined
      : {
          min: data.estimates.min[name],
          max: data.estimates.max[name],
        },
  })

  const finalPrice = tripPriceBuilder(getPricePart('price'), data.currency)
  const originalPrice = tripPriceBuilder(
    getPricePart('original_price'),
    data.currency
  )
  const couponDiscount = tripPriceBuilder(
    getPricePart('coupon_discount'),
    data.currency
  )

  const chargablePrice = data.chargeable_price

  return {
    currency: finalPrice.currencyCode,
    amenities: [],
    couponCode: data.coupon_code || '',
    rewardPoints: 0,
    gratuity: '',
    bookingFee: '',
    bookingFeeValue: 0,
    bookingFeeOriginal: '',
    couponDiscount: couponDiscount.total,
    couponDiscountRaw: couponDiscount.raw,
    pricePerVehicle: '',
    pricePerVehicleRaw: 0,
    originalPrice: originalPrice.total,
    originalPriceRaw: originalPrice.raw,
    diffPrice: '',
    diffPriceRaw: 0,
    diffPriceStripe: 0,
    reservationPrice: '',
    reservationPriceRaw: 0,
    finalPrice: finalPrice.total,
    finalPriceCompact: finalPrice.total,
    finalPriceRaw: finalPrice.raw,
    finalPriceUsd: 0,
    finalPriceUsdStripe: 100, // FIXME: until we do not have that in the response
    finalPriceStripe: 100, // FIXME: until we do not have that in the response
    finalChargeStripePrice: chargablePrice.smallest_currency_unit,
    finalChargeCurrency: chargablePrice.currency,
    finalChargePrice: chargablePrice.display,
    meetAndGreetPrice: '',
    gratuityPercents: 0,
    gratuityRaw: 0,
    returnDisclaimer: '',
    disclaimer: '',
    platformFee: '',
    priceWithoutPlatformFee: '',
    forceThreeDSecure: data.force_3d_secure,
    postPayment: false,
    canUseReservationCard: false,
    requirePaymentDetails: true,
    supports: {
      creditCard: true,
      directBill: false,
    },
  }
}

export default buildOndemandPriceUpdate
